<template>
  <div>
    <b-table
      :id="'project-history-table'"
      bordered
      :ref="'project-history-table'"
      head-variant="light"
      :fields="fields"
      :items="projectAdjustmentItems"
      class="list-item-table"
      show-empty>
      <template v-slot:cell(fundingSource)="row">
        {{ getFundingSource(row.item) }}
      </template>
    </b-table>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ProjectTotalsCalculator from '@/mixins/projectTotalsCalculator';

export default {
  name: 'ProjectBudgetHistory',
  components: {
  },
  mixins: [
    ProjectTotalsCalculator,
  ],
  computed: {
    ...mapState('Project', {
      fundingSources: (state) => state.fundingSources,
      projectBudget: (state) => state.projectBudget,
      projectSnapshot: (state) => state.projectSnapshot,
    }),
    projectAdjustmentItems() {
      let historyItems = [];
      if (this.projectBudget && this.projectSnapshot) {
        historyItems = historyItems.concat(this.projectBudget.projectBudgetYears
          .flatMap((years) => years.annualBudgetIncreases)
          .filter((adj) => adj.adjustmentToProjectBudget > 0)
          .map((adj) => ({
            eventType: 'Budget Increased',
            changeToBudget: adj.adjustmentToProjectBudget,
            eventDate: adj.createdAt,
            createdBy: adj.createdByName,
            fundingSourceId: adj.fundingSourceId,
          })));
        historyItems = historyItems.concat(this.projectBudget.projectBudgetDecreases
          .filter((dec) => dec.decreaseAmount > 0)
          .map((dec) => ({
            eventType: 'Budget Decreased',
            changeToBudget: -(dec.decreaseAmount),
            eventDate: dec.createdAt,
            createdBy: dec.createdByName,
            fundingSourceId: dec.fundingSourceId,
          })));
        historyItems.push({
          eventType: 'Budget Approved',
          changeToBudget: 0.0,
          eventDate: this.projectSnapshot.createdAt,
          createdBy: this.projectSnapshot.createdByName,
          fundingSourceId: 0,
        });
      }
      let runningTotal = this.projectSnapshot.totalProjectCost;
      return historyItems
        .sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate))
        .map((item) => {
          runningTotal += item.changeToBudget;
          /* eslint-disable-next-line no-param-reassign */
          item.budgetTotal = runningTotal;
          return item;
        }).reverse();
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'eventType',
          label: 'Event Type',
          class: 'text-column',
        },
        {
          key: 'changeToBudget',
          label: 'Change to Budget',
          class: 'price-column',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
        },
        {
          key: 'budgetTotal',
          label: 'Budget Total',
          class: 'price-column',
          formatter: (value) => {
            if (!value) {
              return this.$options.filters.toCurrency(0.0);
            }
            return this.$options.filters.toCurrency(value);
          },
        },
        {
          key: 'eventDate',
          label: 'Event Date',
          formatter: (value) => {
            let newVal = value;
            if (typeof value === 'string') {
              newVal = new Date(value);
            }
            return newVal ? newVal.toLocaleDateString('en-US', { type: 'short' }) : null;
          },
          class: 'date-column',
        },
        {
          key: 'createdBy',
          label: 'Changed By',
          class: 'text-column',
        },
        {
          key: 'fundingSource',
          label: 'Funding Source',
          class: 'text-column',
        },
      ],
    };
  },
};
</script>
